import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class IsEligibleForSubmitGuard implements CanActivate {

  private CanSubmitService: boolean = false;
  private baseUrl: string;

  constructor(private http: HttpClient, private router: Router, private appConfig: AppConfigService) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let serviceId = route.data.service;
    LoaderService.showLoader();

    return this.http.get(this.baseUrl + '/api/UserDataManager/IsEligibleForSubmit?serviceId=' + serviceId).pipe(
      map((response: IGetOperationResponse<boolean>) => {
        if (response && response.Result) {
          this.CanSubmitService = true;
          return this.CanSubmitService;
        } else {
          this.router.navigateByUrl('/error');
          LoaderService.hideLoader();
          return false;
        }
      }), catchError(err => {
        LoaderService.hideLoader()
        return of(false);
      }));

  }
  path: import("@angular/router").ActivatedRouteSnapshot[]; route: import("@angular/router").ActivatedRouteSnapshot;

}
